import $ from 'jquery';
import 'slick-carousel';
import getLayout from './get-modal-layout';
import {getSiblings} from './utils';
import Modal from './modal';

const classNames = {
  options: {
    optionActive: `modal-floors__option--active`
  },
  footer: {
    static: `page-footer--static`
  }
};

class ModalGallery extends Modal {
  constructor() {
    super();
    this.toggle = this.page.querySelector(`.flat-page__gallery`);
  }

  init(galleries) {
    super.createModal();
    this.images = galleries;
    this.createGalleryWrap();
    this.bindHandlers();
  }

  createGalleryWrap() {
    super.addLayout(getLayout(`flat-gallery`));
    this.createGallery();
  }

  createGallery() {
    const gallery = this.page.querySelector(`#flat-gallery`);
    const wrap = document.createElement(`div`);
    const getImagesLayout = (src) => {
      return `<div class="modal-gallery__image">
                <img src="${src}" alt="Картинка">
             </div>`
    };
    const images = this.images[0].map(getImagesLayout).join(``);

    wrap.className = `modal__slider modal-gallery`;
    wrap.innerHTML = images;
    this.slider = wrap;
    gallery.appendChild(wrap);
    this.initSlider();
  };

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
  };

  initSlider = () => {
    $(this.slider).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
    });
  };

  bindHandlers() {
    this.toggle.addEventListener(`click`, (ev) => {
      ev.preventDefault();
      this.toggleModal(true);
    });
  }
}

const modalGallery = new ModalGallery();

export default modalGallery;
